<app-go-navigation>
    <div
        class="w-full justify-center min-h-screen overflow-hidden max-w-3xl mx-auto !text-tertiary-900"
    >
        <h1>Fees</h1>

        <h3>
            Cevo Go® features an all-inclusive solution for your application
            preparation, frequency coordination, and FCC filing requirements. A
            single fee, based on
            <a
                [href]="externalLinks.enterpriseWireless.serviceFees"
                target="_blank"
                rel="noopener noreferrer"
                >posted rates</a
            >, is determined by:
        </h3>

        <ul class="list-disc list-outside pl-6 text-base">
            <li>
                Is your application for a new license or a license modification?
            </li>
            <li>
                Will you have fixed locations or is it a mobile only request?
            </li>
            <li>Do you require shared or exclusive frequencies?</li>
            <li>How many frequencies do you require?</li>
            <li>
                Membership in EWA provides discounted rates for certain fee
                elements.
            </li>
        </ul>

        <h3 class="!mt-4">Member Fee Examples (inclusive of FCC fees):</h3>

        <ul class="list-disc list-outside pl-6 text-base">
            <li>
                Five-channel Mobile Only application: $445 to modify, $545 for a
                new license.
            </li>
            <li>
                One shared channel, one fixed location: $505 to modify, $605 for
                a new license (additional channels are $195 per
                frequency/location).
            </li>
            <li>
                Fixed location, one exclusive frequency pair: $780 to modify,
                $880 for a new license (add $195 per additional frequency, up to
                five).
            </li>
            <li>
                For more applications that require more locations and
                frequencies, please contact your EWA Spectrum Advisor for a
                quote.
            </li>
        </ul>

        <p class="!mt-10 text-base">
            A single fee is presented when your spectrum availability results
            are ready. It is also emailed to you upon your confirmation of the
            order. Fees are not assessed until your EWA Spectrum Advisor
            transmits your application to the FCC.
        </p>
    </div>
</app-go-navigation>
